import FiltersLookupBuilder from './FiltersLookupBuilder';

const uuidv1 = require('uuid/v1');

export default class FiltersService {
  static selected = [];
  static testConfig = {};
  static init(type, patternId) {
    this.selected = [];
    this.testConfig = {};
    const filtersLookup = FiltersLookupBuilder.build();
    const allFilters = filtersLookup.get(type);
    const baseline = allFilters.find(item => item.baseline);
    const withoutFilters = allFilters.filter(item => !item.baseline);
    // shuffle
    withoutFilters.sort(() => Math.random() - 0.5);
    // FiltersService.shuffleItems(withoutFilters);
    const filtersWithBaseline = [];
    withoutFilters.forEach((item) => {
      filtersWithBaseline.push(item);
      filtersWithBaseline.push(baseline);
    });
    let count = 0;
    const filtersWithOrder = filtersWithBaseline.map((item) => {
      count += 1;
      return Object.assign({ sortOrder: count }, item);
    });
    // reverse because array.pop method will remove the last item and we want to process them in order
    const filtersWithOrderReversed = filtersWithOrder.reverse();
    this.testConfig = {
      baseline,
      testType: type,
      testPattern: patternId,
      filters: filtersWithOrderReversed,
      testId: uuidv1(),
    };
  }

  static localStorageId = 'history';
  static getHistory() {
    let history = null;
    let historyStr = localStorage.getItem(this.localStorageId);
    if (historyStr) {
      history = JSON.parse(historyStr);
    }
    return history;
  }
  static getRun(testId) {
    let res = null;
    let history = this.getHistory();
    if (history) {
      res = history.find(item => item.testId === testId);
    }
    return res
  }

  static saveToLocalStorage(newRun) {
    let historyStr = localStorage.getItem(this.localStorageId);
    let history = null;
    if (historyStr) {
      history = JSON.parse(historyStr);
      // serder to/from json so date is in the string format
      const converted = JSON.parse(JSON.stringify(newRun));
      history.push(converted);

      if (history.length > 10) {
        history = history.sort((a,b) => b.date.localeCompare(a.date));
        history.pop();
      }
    }
    if (!history) {
      history = [newRun];
    }
    localStorage.setItem(this.localStorageId, JSON.stringify(history));
  }

  static report(selectedItem) {
    this.selected.push(selectedItem);
  }
  static buildResults(testId) {
    let res = this.getRun(testId);
    if (!res && this.testConfig && this.testConfig.testId) {
      const playoffRounds = this.getPlayoffRounds();
      res = {
        testId: this.testConfig.testId,
        testType: this.testConfig.testType,
        testPattern: this.testConfig.testPattern,
        date: new Date(),
        filters: this.selected.filter(item => !item.playoff),
        preferred: this.getPreferred(playoffRounds, this.selected),
        playoffRounds,
      };
      this.saveToLocalStorage(res);
    }
    return res;
  }
  static getPreferred(playoffRounds, incomingFilters) {
    // if there is playoff then just grab it from the last playoff, trusting that playoff logic did the right thing
    if (playoffRounds && playoffRounds.length > 0) {
      const lastPlayoffRun = playoffRounds[playoffRounds.length - 1];
      return this.getPreferred([], lastPlayoffRun.filters);
    }

    // only consider anything over 0
    const filtersWithPositiveRating = incomingFilters.filter(item => item.rating > 0);
    if (!filtersWithPositiveRating || filtersWithPositiveRating.length === 0) {
      return [];
    }
    // keep only 1 reference number
    // only keep 1 baseline color with the maximum rating
    const withBaseLine = filtersWithPositiveRating.filter(item => item.baseline === true);
    const filtersToConsider = filtersWithPositiveRating.filter(item => item.baseline === false);
    if (withBaseLine && withBaseLine.length > 0) {
      withBaseLine.sort((a, b) => a.rating - b.rating);
      const maxBaselineItem = withBaseLine.pop();
      filtersToConsider.push(maxBaselineItem);
    }

    const ratingsArr = filtersToConsider.map(item => item.rating);
    const maxRating = Math.max(...ratingsArr);
    const preferredFilters = filtersToConsider.filter(item => item.rating === maxRating);
    return preferredFilters;
  }
  static getPlayoffRounds() {
    const playOffItems = this.selected.filter(item => item.playoff);
    playOffItems.sort((a, b) => b.playoffRun - a.playoffRun);
    const playoffRounds = new Map();
    playOffItems.forEach((item) => {
      const key = item.payoffRun;
      const collection = playoffRounds.get(key);
      if (!collection) {
        playoffRounds.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    const res = Array.from(playoffRounds).map(([key, value]) => ({ round: key, filters: value }));
    return res;
  }
}
